import React from 'react';
import PropTypes from 'prop-types';
import './AnonymousDocsDisplay.scss';
import * as classnames from 'classnames';
import verified from './verificationStateIcons/verified.svg';
import failed from './verificationStateIcons/failed.svg';
import pending from './verificationStateIcons/pending.svg';
import Translate from '../i18n/Translate/Translate';
import { translate } from '../i18n/Translate';
import iconDoc from '../assets/img/doc-icon.svg';

const AnonymousDocsDisplay = (props) => {
  const {
    docStatus,
    title,
    notice,
    onDelete,
    id,
    callback,
    thumbnail,
    fileType,
    isUserNotVerified,
  } = props;
  const isVerified = docStatus === 'verified';
  const isFailed = docStatus === 'not-verified';
  const isPending = docStatus === 'pending' || docStatus === 'manual-review';

  const getSrc = () => {
    if (!thumbnail) {
      switch (docStatus) {
        case 'verified':
          return verified;
        case 'not-verified':
          return failed;
        default:
          return pending;
      }
    }

    const checkImg = fileType && (fileType.startsWith('image') || ['jpg', 'jpeg', 'png', 'svg'].includes(fileType.toLowerCase()));
    return checkImg ? thumbnail : iconDoc;
  };

  const docsStatus = ()=> (
    <span
      className={classnames('anonymous-docs__verified-status', {
        'anonymous-docs__verified-status--success': isVerified,
        'anonymous-docs__verified-status--failed': isFailed,
        'anonymous-docs__verified-status--pending': isPending,
      })}
    >
        <span className="font-14">
          <i className={classnames({
            'icon-check': isVerified,
            'icon-exit': isFailed,
            'icon-clock': isPending,
          })}
          />
          {isPending && <Translate translationKey="Texts.pending" />}
          {isVerified && <Translate translationKey="Texts.verified" />}
          {isFailed && <Translate translationKey="Texts.not-verified" />}
        </span>
      </span>
  )

  return (
    <div className="anonymous-docs position-relative">
      <div className="anonymous-docs__title mb-3">
        <span className="font-14 mb-0 mr-3">
          <Translate translationKey={title} />
        </span>
        {isUserNotVerified && (
          <button
            id="file-delete"
            className="border-0 bg-white text-danger font-12 px-0"
            type="button"
            onClick={() => onDelete(id, callback)}
          >
            <Translate translationKey="Texts.delete" />
          </button>
        )}
        {docsStatus()}
      </div>

      <div className={classnames('anonymous-docs__docs-display', {
        'anonymous-docs__docs-display--success': isVerified,
        'anonymous-docs__docs-display--failed': isFailed,
        'anonymous-docs__docs-display--pending': isPending,
      })}
      >
        <img
          src={getSrc()}
          alt={translate(docStatus)}
        />
      </div>
      {docsStatus()}
      {!!notice && (
        <span className="font-12 pt-2">{notice}</span>
      )}
    </div>
  );
};

AnonymousDocsDisplay.propTypes = {
  docStatus: PropTypes.oneOf(['verified', 'not-verified', 'manual-review', 'pending']),
  title: PropTypes.string,
  notice: PropTypes.string,
  id: PropTypes.string,
  onDelete: PropTypes.func,
  callback: PropTypes.func.isRequired,
  thumbnail: PropTypes.string,
  fileType: PropTypes.string,
  isUserNotVerified: PropTypes.bool.isRequired,
};
AnonymousDocsDisplay.defaultProps = {
  docStatus: 'pending',
  title: '',
  notice: '',
  id: '',
  onDelete: () => null,
  thumbnail: '',
  fileType: '',
};

export default AnonymousDocsDisplay;
